'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdGpsFixed = function MdGpsFixed(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm20 31.6q4.8 0 8.2-3.4t3.4-8.2-3.4-8.2-8.2-3.4-8.2 3.4-3.4 8.2 3.4 8.2 8.2 3.4z m14.9-13.2h3.5v3.2h-3.5q-0.5 5.3-4.3 9t-9 4.3v3.5h-3.2v-3.5q-5.3-0.5-9-4.3t-4.3-9h-3.5v-3.2h3.5q0.5-5.3 4.3-9t9-4.3v-3.5h3.2v3.5q5.3 0.5 9 4.3t4.3 9z m-14.9-5q2.7 0 4.7 1.9t1.9 4.7-1.9 4.7-4.7 1.9-4.7-1.9-1.9-4.7 1.9-4.7 4.7-1.9z' })
        )
    );
};

exports.default = MdGpsFixed;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/gps-fixed.js
// module id = 2914
// module chunks = 0